import add from './add';
import remove from './remove';
import notify from './notify';

const EventObserver = function() {};

EventObserver.prototype = {
  observers: [],
  add,
  remove,
  notify,
};

const eventObserver = new EventObserver();

export default eventObserver;
